var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _mask, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowcaseGraphic1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 302,
    viewBox: "0 0 302 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 100,
    height: 100,
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 101,
    width: 100,
    height: 100,
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 201,
    width: 100,
    height: 100,
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 101,
    width: 100,
    height: 100,
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 201,
    width: 100,
    height: 100,
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 201,
    width: 100,
    height: 100,
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126 1C112.193 1 101 12.1929 101 26C101 39.8071 112.193 51 126 51C112.193 51 101 62.1929 101 76C101 89.8071 112.193 101 126 101C139.807 101 151 89.8071 151 76C151 89.8071 162.193 101 176 101C189.807 101 201 89.8071 201 76C201 62.1929 189.807 51 176 51C189.807 51 201 39.8071 201 26C201 12.1929 189.807 1 176 1C162.193 1 151 12.1929 151 26C151 12.1929 139.807 1 126 1Z",
    fill: "#9BB7FF",
    stroke: "#F0F4C3",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-1_27_16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301 123.34C301 128.563 296.99 133.366 290.27 137.17C296.99 140.974 301 145.778 301 151C301 156.222 296.99 161.026 290.27 164.83C296.99 168.634 301 173.437 301 178.659C301 190.998 278.614 201 251 201C223.386 201 201 190.998 201 178.659C201 173.437 205.01 168.634 211.73 164.83C205.01 161.026 201 156.222 201 151C201 145.778 205.01 140.974 211.73 137.17C205.01 133.366 201 128.563 201 123.34C201 111.002 223.386 101 251 101C278.614 101 301 111.002 301 123.34Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301 123.34C301 128.563 296.99 133.366 290.27 137.17C296.99 140.974 301 145.778 301 151C301 156.222 296.99 161.026 290.27 164.83C296.99 168.634 301 173.437 301 178.659C301 190.998 278.614 201 251 201C223.386 201 201 190.998 201 178.659C201 173.437 205.01 168.634 211.73 164.83C205.01 161.026 201 156.222 201 151C201 145.778 205.01 140.974 211.73 137.17C205.01 133.366 201 128.563 201 123.34C201 111.002 223.386 101 251 101C278.614 101 301 111.002 301 123.34Z",
    fill: "#43A047"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M290.27 137.17L289.285 135.43L286.211 137.17L289.285 138.911L290.27 137.17ZM290.27 164.83L289.285 163.089L286.211 164.83L289.285 166.57L290.27 164.83ZM211.73 164.83L212.715 166.57L215.789 164.83L212.715 163.089L211.73 164.83ZM211.73 137.17L212.715 138.911L215.789 137.17L212.715 135.43L211.73 137.17ZM291.256 138.911C298.178 134.992 303 129.665 303 123.34H299C299 127.46 295.802 131.74 289.285 135.43L291.256 138.911ZM303 151C303 144.675 298.178 139.348 291.256 135.43L289.285 138.911C295.802 142.6 299 146.881 299 151H303ZM291.256 166.57C298.178 162.652 303 157.325 303 151H299C299 155.119 295.802 159.4 289.285 163.089L291.256 166.57ZM289.285 166.57C295.802 170.26 299 174.54 299 178.659H303C303 172.335 298.178 167.008 291.256 163.089L289.285 166.57ZM299 178.659C299 181.097 297.903 183.567 295.618 185.98C293.324 188.404 289.91 190.678 285.539 192.631C276.803 196.534 264.593 199 251 199V203C265.021 203 277.811 200.465 287.171 196.283C291.849 194.193 295.757 191.652 298.523 188.73C301.299 185.798 303 182.391 303 178.659H299ZM251 199C237.407 199 225.197 196.534 216.461 192.631C212.09 190.678 208.676 188.404 206.382 185.98C204.097 183.567 203 181.097 203 178.659H199C199 182.391 200.701 185.798 203.477 188.73C206.243 191.652 210.151 194.193 214.829 196.283C224.189 200.465 236.979 203 251 203V199ZM203 178.659C203 174.54 206.198 170.26 212.715 166.57L210.744 163.089C203.822 167.008 199 172.335 199 178.659H203ZM199 151C199 157.325 203.822 162.652 210.744 166.57L212.715 163.089C206.198 159.4 203 155.119 203 151H199ZM210.744 135.43C203.822 139.348 199 144.675 199 151H203C203 146.881 206.198 142.6 212.715 138.911L210.744 135.43ZM199 123.34C199 129.665 203.822 134.992 210.744 138.911L212.715 135.43C206.198 131.74 203 127.46 203 123.34H199ZM251 99C236.979 99 224.189 101.535 214.829 105.717C210.151 107.807 206.243 110.348 203.477 113.27C200.701 116.202 199 119.609 199 123.34H203C203 120.903 204.097 118.433 206.382 116.019C208.676 113.596 212.09 111.322 216.461 109.369C225.197 105.466 237.407 103 251 103V99ZM303 123.34C303 119.609 301.299 116.202 298.523 113.27C295.757 110.348 291.849 107.807 287.171 105.717C277.811 101.535 265.021 99 251 99V103C264.593 103 276.803 105.466 285.539 109.369C289.91 111.322 293.324 113.596 295.618 116.019C297.903 118.433 299 120.903 299 123.34H303Z",
    fill: "#F0F4C3",
    mask: "url(#path-8-inside-1_27_16)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcaseGraphic1);
export default __webpack_public_path__ + "static/media/showcaseGraphic1.fc6ecf32edc6c4aa542aec73bcc502c5.svg";
export { ForwardRef as ReactComponent };